// @core/api/endpoints/userprofile/delete_banner.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/userprofile';

/**
 * Delete banner
 * Permanently deletes a banner image and its associated data. If the active banner is deleted, the profile will display without a banner.
 */
export async function DeleteBanner(
  profile_id: string,
  banner_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:profile_id/banners/:banner_id`;
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  requestPath = requestPath.replace(':banner_id', encodeURIComponent(banner_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
